import { Header } from "@/components/site/Header";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { usePageSeo } from "@/lib/seo";

export default function ContactPage() {
  usePageSeo({
    path: "/contact",
    title: "Contact | Park Communications — Strategic Communications & Crisis PR",
    description:
      "Contact Park Communications, a strategic communications agency and crisis PR firm. Get crisis management help or hire a crisis communications consultant — every message is read personally and held in confidence.",
  });

  return (
    <main data-testid="contact-page">
      <Header solid linkBase="/" />
      <div className="h-20 bg-navy" aria-hidden="true" />
      <Contact />
      <Footer />
    </main>
  );
}
